export default __webpack_public_path__ + "static/media/mtText.d53a9778.png";